var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCart = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--cart",
  viewBox: "0 0 34.1 46.5",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.4 17c.1 1-1.4 1.2-1.5.2l-.9-6.6c-.9-6.7 9.3-7 10.2-.2l.9 6.5c.1 1-1.4 1.2-1.5.2l-.9-6.5c-.7-4.6-7.8-4.8-7.2-.2l.9 6.6zm11.9-4.5l1.8 23.2-18.4 5.4L4 36.4l1.9-24 5.9-.7 1.8.1.2 1.6-1.2-.1v25.9l15.8-4.6L26.8 14l-1.6-.1-.2-1.6 3.3.2zm-12-.6l5.9.3.2 1.6-5.9-.3-.2-1.6zm1.9-.5l.1-1c.2-1.2-.2-2.1-.8-2.7.7-.2 1.3-.2 2 0 .4.8.6 1.7.4 2.9l-.1.8h-1.6zM14 7.3c-1.3.5-2.5 1.6-2.7 3.4l-.1.5-1.6.2.1-.9c.5-3.6 3.5-5.2 6.2-4.9-.8.3-1.5.9-1.9 1.7zm-3 31.5V13.3l-3.7.4-1.7 21.9 5.4 3.2z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconCart.6fbfe5db.svg";
export { ForwardRef as ReactComponent };